var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-association-region-plot" },
    [
      _vm.showLegend
        ? _c("div", { staticClass: "vks-association-region-plot-legend" }, [
            _vm._m(0),
            _vm._m(1),
            _vm._m(2),
            _vm._m(3),
            _vm._m(4),
            _vm._m(5),
            _vm._m(6),
            _vm._m(7),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          ref: "canvasWrap",
          staticClass: "vks-association-region-plot-canvas-wrap",
        },
        [
          _c("canvas", {
            ref: "canvas",
            staticClass: "vks-association-region-plot-canvas",
            class: {
              "is-pannable": _vm.canPan,
              "is-x-axis-hover": _vm.xAxisBandHover,
              "is-dot-hover": _vm.dotHover,
            },
            on: {
              mousedown: _vm.onMouseDown,
              mousemove: _vm.onMouseMove,
              mouseout: _vm.onMouseOut,
              mouseup: _vm.onMouseUp,
              click: _vm.onCanvasClick,
            },
          }),
          _vm.showViewRegionHandle && _vm.viewRegionHandleStyle
            ? _c(
                "div",
                {
                  staticClass: "gp2-view-region-handle",
                  class: {
                    "is-dragging": _vm.isDraggingViewHandle,
                    "is-hovered": _vm.isHoveringViewHandle,
                  },
                  style: _vm.viewRegionHandleStyle,
                  attrs: {
                    role: "slider",
                    tabindex: "0",
                    "aria-label": `Viewing region (${_vm.viewingRegionWidthLabel}) handle — drag to move viewing region`,
                    title: _vm.viewRegionHandleTitle,
                  },
                  on: {
                    mouseenter: function ($event) {
                      _vm.isHoveringViewHandle = true
                    },
                    mouseleave: function ($event) {
                      _vm.isHoveringViewHandle = false
                    },
                    mousedown: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.onViewHandleMouseDown.apply(null, arguments)
                    },
                    keydown: _vm.onViewHandleKeyDown,
                  },
                },
                [_vm._m(8)]
              )
            : _vm._e(),
          _vm.showViewRegionBridge && _vm.viewRegionConnectorStyle
            ? _c("div", {
                staticClass: "gp2-view-region-connector",
                class: {
                  "is-active":
                    _vm.isHoveringViewHandle || _vm.isDraggingViewHandle,
                },
                style: _vm.viewRegionConnectorStyle,
                attrs: { "aria-hidden": "true" },
              })
            : _vm._e(),
          _vm.showViewRegionBridge && _vm.viewRegionBridgeStyle
            ? _c(
                "div",
                {
                  staticClass: "gp2-view-region-bridge",
                  class: {
                    "is-active":
                      _vm.isHoveringViewHandle || _vm.isDraggingViewHandle,
                  },
                  style: _vm.viewRegionBridgeStyle,
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("span", { staticClass: "gp2-view-region-bridge-top" }),
                  _c("span", {
                    staticClass:
                      "gp2-view-region-bridge-edge gp2-view-region-bridge-edge--left",
                  }),
                  _c("span", {
                    staticClass:
                      "gp2-view-region-bridge-edge gp2-view-region-bridge-edge--right",
                  }),
                  _vm._l(_vm.bridgeExonMarks, function (mark) {
                    return _c("span", {
                      key: mark.key,
                      staticClass: "gp2-view-region-bridge-exon",
                      style: {
                        left: `${mark.left}%`,
                        width: `${mark.width}%`,
                        backgroundColor: mark.color,
                      },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _vm.showViewRegionBridge && _vm.bridgeViewGenes.length
        ? _c(
            "div",
            {
              staticClass: "gp2-view-region-bridge-genes",
              attrs: { "aria-label": "Genes overlapping the viewing region" },
            },
            _vm._l(_vm.bridgeViewGenes, function (gene) {
              return _c(
                "span",
                {
                  key: gene.name,
                  staticClass: "gp2-view-region-bridge-gene",
                  style: { color: gene.color },
                },
                [_vm._v(" " + _vm._s(gene.name) + " ")]
              )
            }),
            0
          )
        : _vm._e(),
      _c("VariantSifterVariantDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          "variant-id": _vm.dotMenuVariantId,
          "is-starred": _vm.dotMenuIsStarred,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: {
          "set-reference": _vm.onDotMenuSetReference,
          "toggle-star": _vm.onDotMenuToggleStar,
        },
      }),
      _c("div", {
        ref: "tooltip",
        staticClass: "vks-association-region-plot-tooltip hidden",
      }),
      _vm.loading
        ? _c("p", { staticClass: "vks-association-region-plot-status" }, [
            _vm._v(" Loading plot overlays… "),
          ])
        : _vm._e(),
      _vm.error
        ? _c(
            "p",
            {
              staticClass: "vks-association-region-plot-error",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-diamond",
        attrs: { "aria-hidden": "true" },
      }),
      _c("span", [_vm._v("Reference variant")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#82409950" },
      }),
      _c("span", [_vm._v("r2 == 1")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#d0363350" },
      }),
      _c("span", [_vm._v("1 > r2 >= 0.8")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#ee982d50" },
      }),
      _c("span", [_vm._v("0.8 > r2 >= 0.6")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#4db05250" },
      }),
      _c("span", [_vm._v("0.6 > r2 >= 0.4")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#32afd550" },
      }),
      _c("span", [_vm._v("0.4 > r2 >= 0.2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#2074b650" },
      }),
      _c("span", [_vm._v("0.2 > r2 > 0")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "vks-legend-item" }, [
      _c("span", {
        staticClass: "plot-legend-dot",
        staticStyle: { "background-color": "#33333320" },
      }),
      _c("span", [_vm._v("No data")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "gp2-view-region-handle-bracket",
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("span", {
          staticClass:
            "gp2-view-region-handle-edge gp2-view-region-handle-edge--left",
        }),
        _c("span", { staticClass: "gp2-view-region-handle-bar" }),
        _c("span", {
          staticClass:
            "gp2-view-region-handle-edge gp2-view-region-handle-edge--right",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }